import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';


class DeleteConfirm extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    name: PropTypes.string,
    headerNode: PropTypes.node,
    content: PropTypes.node,
    t: PropTypes.func,
  }
  shouldComponentUpdate(nextProps) {
    if (this.props.name !== nextProps.name ||
    (this.props.open !== nextProps.open)) {
      return true;
    }
    return false;
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        basic
        open={this.props.open === true}
        onClose={this.handleOnClose}
        size="small"
      >
        <Header icon="warning sign" content={this.props.headerNode || t('WARNING: Delete Confirmation', { ns: TRANSLATION_FILES.translation })} />
        <Modal.Content>
          <Modal.Description>
            {
              this.props.content || (
              <p>
                <Trans
                  ns={TRANSLATION_FILES.translation}
                  i18nKey="Are you sure you want to permanently delete <strong>{{name}}</strong>?"
                  values={{ name: this.props.name || this.props.t('this', { ns: TRANSLATION_FILES.translation }) }}
                >
                  Are you sure you want to permanently delete <strong>{"'{name}'"}</strong>?
                </Trans>
              </p>
              )
            }
            <p><small>{t('This cannot be undone.', { ns: TRANSLATION_FILES.translation })}</small></p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleOnClose} content={t('Cancel', { ns: TRANSLATION_FILES.screens })} />
          <Button negative onClick={this.handleOnComfirm} icon="trash" content={t('Delete', { ns: TRANSLATION_FILES.translation })} />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(DeleteConfirm);



// WEBPACK FOOTER //
// ./src/containers/modals/DeleteConfirm.jsx